import {Box, Modal, Text} from '@mantine/core';
import type React from 'react';
import type {HashtagCategoryType} from '../../../../../core/entities/entrysheetBuilder/constants';
import {hashtagCategoryDictionary} from '../../../../../core/entities/register/constants';
import type {GetHashtagType} from '../../../../../core/entities/register/schema';
import {useGetHashtagList} from '../../../../../core/repositories/skillRepository';

type Props = {
  hashtagCategory: HashtagCategoryType | undefined;
  onClose: () => void;
  handleSelectHashtag: (hashtag: GetHashtagType) => void;
};

export const SelectHashtagModal: React.FC<Props> = ({
  hashtagCategory,
  onClose,
  handleSelectHashtag,
}) => {
  const {data} = useGetHashtagList({
    categoryID: hashtagCategoryDictionary.technology,
    group: hashtagCategory?.key,
  });

  return (
    <Modal
      opened={Boolean(hashtagCategory)}
      onClose={onClose}
      withCloseButton
      className="h-[90%] relative m-auto overflow-y-scroll mx-auto bg-white"
      title={
        <Box className="pl-12 text-md font-bold">{hashtagCategory?.name}</Box>
      }
    >
      <Box className="flex flex-col mx-auto items-center gap-y-16 pc:py-20 pc:px-[40px]">
        {data?.ok &&
          data.value.hashtags.map((hashtag) => (
            <Text
              key={hashtag.id}
              className="cursor-pointer"
              onClick={() => {
                handleSelectHashtag(hashtag);
              }}
            >
              {hashtag.name}
            </Text>
          ))}
      </Box>
    </Modal>
  );
};
